<template>
  <div class="loading-mask" v-show="visible" :style="{ background: background || '' }">
    <div class="loading-spinner">
      <img :src="ossPath + '/logo/logo_loding.gif'" alt="logo" class="logo">
      <div class="text">{{ text }}</div>
    </div>
  </div>
</template>
<script>
import { ossPath } from '../devParams';

export default {
  name: 'logoLoading',
  data() {
    return {
      visible: false,
      text: '加载中...',
      background: null
    }
  }
}
</script>
<style lang="scss" scoped>
.loading-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  background: hsla(0,0%,100%,.9);
  transition: opacity .3s;
  user-select: none;
  .loading-spinner {
    top: 50%;
    width: 100%;
    transform: translateY(-50%);
    text-align: center;
    position: absolute;
    .logo {
      width: 80px;
      height: 80px;
    }
    .text {
      color: #FF4D01;
      font-family: PingFangSC, PingFang SC;
    }
  }
}
</style>



// WEBPACK FOOTER //
// common/logoLoading.vue